import type { ReactNode } from 'react';

/** EPN-80 — a reusable "nothing here yet" notice with an optional call-to-action, so a genuinely-empty,
 * genuinely-authorized state reads as "nothing set up yet" rather than looking broken or identical to an
 * access-denied/error state. */
export function EmptyState({ message, action }: { message: string; action?: ReactNode }) {
  return (
    <div className="empty-state">
      <p className="muted">{message}</p>
      {action}
    </div>
  );
}
